module.exports = __webpack_public_path__ + "static/media/thea.6927b0ea.jpeg";